import axios from 'axios';
import { auth } from '../../firebase';
import { API_CONFIG } from '../../config/api.config';

// Création de l'instance Axios
const axiosInstance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

console.log('Axios instance created with base URL:', API_CONFIG.BASE_URL);

// Solution au problème de typage: utiliser une assertion de type explicite
axiosInstance.interceptors.request.use(
  function(config) {
    console.log('🌐🌐🌐 AXIOS REQUEST INTERCEPTOR START');
    console.log('🌐 Request URL:', config.url);
    console.log('🌐 Request method:', config.method);
    
    // Utiliser le token Firebase si disponible
    if (auth.currentUser) {
      console.log('🌐 Firebase user found, getting token...');
      // On ne peut pas retourner une promesse ici car TypeScript attend un objet de configuration
      // On utilise donc un "any" temporairement pour contourner le problème de typage
      return auth.currentUser.getIdToken(false).then(token => {
        console.log('🌐 Firebase token obtained:', token.substring(0, 20) + '...');
        if (config.headers) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        
        // Ajouter le réseau sélectionné aux headers si disponible
        const selectedNetwork = localStorage.getItem('selectedNetwork');
        console.log('🌐 Selected network from localStorage:', selectedNetwork);
        if (selectedNetwork && config.headers) {
          config.headers['X-Selected-Network'] = selectedNetwork;
        }
        
        // Ajouter l'ID utilisateur impersonné si en mode impersonation
        const impersonatedUserId = localStorage.getItem('impersonatedUserId');
        console.log('🌐 Impersonated user ID from localStorage:', impersonatedUserId);
        if (impersonatedUserId && config.headers) {
          config.headers['X-Impersonated-User-Id'] = impersonatedUserId;
          console.log('🌐 IMPERSONATION HEADER ADDED!');
        }
        
        console.log('🌐 Final headers:', config.headers);
        console.log('🌐🌐🌐 AXIOS REQUEST INTERCEPTOR SUCCESS');
        return config;
      }) as any; // Cette assertion résout le problème de typage
    } 
    
    console.log('🌐 No Firebase user, using fallback token system');
    // Fallback à l'ancien système de token
    const token = localStorage.getItem('token');
    console.log('🌐 Token from localStorage:', token ? token.substring(0, 20) + '...' : 'NULL');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
      
      // Ajouter le réseau sélectionné aux headers si disponible
      const selectedNetwork = localStorage.getItem('selectedNetwork');
      console.log('🌐 Selected network from localStorage:', selectedNetwork);
      if (selectedNetwork) {
        config.headers['X-Selected-Network'] = selectedNetwork;
      }
      
      // Ajouter l'ID utilisateur impersonné si en mode impersonation
      const impersonatedUserId = localStorage.getItem('impersonatedUserId');
      console.log('🌐 Impersonated user ID from localStorage:', impersonatedUserId);
      if (impersonatedUserId) {
        config.headers['X-Impersonated-User-Id'] = impersonatedUserId;
        console.log('🌐 IMPERSONATION HEADER ADDED!');
      }
    }
    
    console.log('🌐 Final headers:', config.headers);
    console.log('🌐🌐🌐 AXIOS REQUEST INTERCEPTOR END');
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// Autre correction pour l'intercepteur de réponse
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const originalRequest = error.config;
      
      // Si ce n'est pas déjà une tentative de rafraîchissement
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        
        // Vérifier si l'utilisateur est connecté avec Firebase
        if (auth.currentUser) {
          // Utiliser une IIFE pour gérer la promesse dans l'intercepteur
          return (async function() {
            try {
              // Ajout de la vérification pour auth.currentUser pour satisfaire TypeScript
              const currentUser = auth.currentUser;
              if (!currentUser) {
                throw new Error('User not authenticated');
              }

              // Forcer un rafraîchissement du token
              const newToken = await currentUser.getIdToken(true);
              
              // Configurer la nouvelle requête avec le token rafraîchi
              if (originalRequest.headers) {
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
              }
              
              // Réessayer la requête
              return await axiosInstance(originalRequest);
            } catch (refreshError) {
              console.error('Failed to refresh token:', refreshError);
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              window.location.href = '/login?session_expired=true';
              return Promise.reject(refreshError);
            }
          })();
        }
      }
      
      // Si la tentative de rafraîchissement a échoué ou si pas d'utilisateur Firebase
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login?session_expired=true';
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;